import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { makeRemoteUpdateAdminType } from 'main/factories/usecases/update-admin-type';
import { FIVE_SECONDS, showToast, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS } from 'lib/utils';
import { UpdateAdminType } from 'domain/usecases/update-admin-type';

export const useUpdateAdminType = (options?: UseMutationOptions<any, Error, UpdateAdminType.Params, unknown>) => {
  const updateAdminTypeService = makeRemoteUpdateAdminType();

  const updateAdminTypeFn = async (params: UpdateAdminType.Params) => {
    return updateAdminTypeService.updateAdminType(params);
  };

  const { onSuccess: customOnSuccess, ...rest } = options || {};

  return useMutation({
    mutationFn: updateAdminTypeFn,

    onError: (error, variables, _context) => {
      showToast(error.message || 'Error updating admin type', TOAST_ERROR, TEN_SECONDS);
    },

    onSuccess: async (_data, variables, _context, mutationContext) => {
      if (customOnSuccess) {
        await customOnSuccess(_data, variables, _context, mutationContext);
      }

      showToast('Admin type updated successfully', TOAST_SUCCESS, FIVE_SECONDS);
    },

    ...rest,
  });
};
